import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as storage from "@/utils/storage";
import * as API from "@/api";
import "@/styles/index.less";
import "@/icons";
import "@/ui";

Vue.prototype.$storage = storage;
Vue.prototype.$api = API;
Vue.prototype.$PRODUCTION = process.env.NODE_ENV === "production";

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
